import type {
  TClientData,
  TClientServerResponse
} from '@/AdminPanel/pages/Clients/types/client.types';
import { ApiConnector } from '@/api/api.connector';

class ClientsApi extends ApiConnector {
  public getAdminAllClients(
    limit?: number,
    page?: number,
    searchTerm?: string
  ): Promise<{
    total: number;
    data: TClientServerResponse[];
  }> {
    return this.call({
      path: 'admin/clients/getClients',
      params: { limit, page, searchTerm }
    });
  }

  public getAdminClientById(id: string): Promise<TClientServerResponse> {
    return this.call({ path: `admin/clients/${id}` });
  }

  public updateClientById(body: TClientData): Promise<TClientData> {
    return this.call({
      path: `admin/clients/${body.uuid}`,
      method: 'patch',
      body
    });
  }
}

export const clientsApi = new ClientsApi();
